import { ReportTop } from "../../../components/Dashboard/ReportLayout";
import { flattenSelection, useFilterContextV2 } from "../../../contexts/FilterContextV2";
import { useEffect, useState } from "react";
import { ReactComponent as BagFood } from "../../../assets/svg/icons/bagFood.svg";
import { FilterDateDashboard } from "../../../components/Dashboard/ViewDatas/FilterDate";
import { useFilter } from "../../../hooks/useFilter";
import Constants from "../../../constants/Index";
import { DateModal } from "../../../components/Modal/DateFilter";

import { ButtonWithChildren } from "../../../components/Buttons/ButtonWithChildren/Index";
import { analyticsService } from "../../../services/analyticsService";
import {
  exportDailySnapshotToExcel,
  exportDailySnapshotByBatchToExcel,
} from "../../../utils/excel/exportDailySnapshot";
import { exportBalanceMovementToExcel } from "../../../utils/excel/exportBalanceMovement";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

export default function ExportDashboard() {
  const { t } = useTranslation();
  const {
    setDashboard,
    setSideBarOptionSelected,
    onBoardingDate,
    rangeDays,
    setRangeDays,
    setSelectRangeDate,
  } = useFilter();

  const selection = useFilterContextV2();
  const selectedFarms = flattenSelection(selection.selectedFarms);
  const selectedAreas = flattenSelection(selection.selectedAreas);

  useEffect(() => {
    setDashboard("EXPORT");
    document.title = Constants.TITLE_EXPORT;
    setSideBarOptionSelected("DASHBOARD");
    setSelectRangeDate(2);

    const now = new Date();
    now.setDate(now.getDate() - 1);

    setRangeDays({
      from: onBoardingDate,
      to: now,
    });
  }, [, onBoardingDate]);

  const [isLoading, setIsLoading] = useState(false);

  const handleExport = async (isByBatch: boolean) => {
    try {
      // Validações

      if (!rangeDays?.from || !rangeDays?.to) {
        alert(t("excelExport.selectPeriod"));
        return;
      }

      if (!selectedFarms.length || !selectedAreas.length) {
        alert(t("excelExport.selectFarmArea"));
        return;
      }
      setIsLoading(true);

      // Preparar parâmetros
      const farmId = selectedFarms.map((farm: any) => Number(farm.value));
      const areaIds = selectedAreas.map((area: any) => Number(area.value));
      const startDate = format(new Date(rangeDays.from), "yyyy-MM-dd");
      const endDate = format(new Date(rangeDays.to), "yyyy-MM-dd");

      // Fazer requisição
      const data = await analyticsService.getDailySnapshot(
        farmId,
        areaIds,
        startDate,
        endDate,
        isByBatch,
      );

      // Exportar para Excel
      const filename = isByBatch
        ? `daily-snapshot-by-batch-${startDate}-to-${endDate}.xlsx`
        : `daily-snapshot-by-microarea-${startDate}-to-${endDate}.xlsx`;

      if (isByBatch) {
        exportDailySnapshotByBatchToExcel(data, filename);
      } else {
        exportDailySnapshotToExcel(data, filename);
      }
    } catch (error) {
      console.error("Erro ao exportar dados:", error);
      alert(t("excelExport.generationError"));
    } finally {
      setIsLoading(false);
    }
  };

  const handleExportByMicroArea = () => handleExport(false);
  const handleExportByBatch = () => handleExport(true);

  const handleExportByMovement = async () => {
    try {

      if (!rangeDays?.from || !rangeDays?.to) {
        alert(t("excelExport.selectPeriod"));
        return;
      }

      if (!selectedFarms?.length || !selectedAreas?.length) {
        alert(t("excelExport.selectFarmArea"));
        return;
      }

      if (!selectedFarms.length || !selectedAreas.length) {
        alert(t("excelExport.selectFarmArea"));
        return;
      }
      setIsLoading(true);

      const farmIds = selectedFarms.map((farm: any) => Number(farm.value));
      const areaIds = selectedAreas.map((area: any) => Number(area.value));
      const startDate = format(new Date(rangeDays.from), "yyyy-MM-dd");
      const endDate = format(new Date(rangeDays.to), "yyyy-MM-dd");

      const data = await analyticsService.getBalanceMovement(
        farmIds,
        areaIds,
        startDate,
        endDate,
      );
      const filename = `movimentacao-gado-${startDate}-to-${endDate}.xlsx`;

      exportBalanceMovementToExcel(data, filename);
    } catch (error) {
      console.error("Erro ao exportar movimentações:", error);
      alert(t("excelExport.generationError"));
    } finally {
      setIsLoading(false);
    }
  };

  const maxDate = new Date();
  maxDate.setDate(maxDate.getDate() - 1);

  return (
    <div
      className="cattleMap_background"
      style={{ height: "100vh", overflowY: "auto" }}
    >
      <DateModal maxDate={maxDate} />

      <form className="dashboardPastureManagement">
        <div className="cattleMap_page">
          <ReportTop icon={<BagFood height={72} />} title={t("excelExport.title")} subtitle={t("excelExport.subtitle")}>
            <div>
              <FilterDateDashboard exportPDF={false} />
              <br />
              <div
                style={{ width: "100%", display: "flex", flexDirection: "column" }}
              >
                <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
                  <ButtonWithChildren
                    onClick={handleExportByMicroArea}
                    theme={isLoading ? "disabled" : undefined}
                    children={isLoading ? t("excelExport.generating") : t("excelExport.dailyPaddock")}
                  />
                  <ButtonWithChildren
                    onClick={handleExportByBatch}
                    theme={isLoading ? "disabled" : undefined}
                    children={isLoading ? t("excelExport.generating") : t("excelExport.dailyBatch")}
                  />
                  <ButtonWithChildren
                    onClick={handleExportByMovement}
                    theme={isLoading ? "disabled" : undefined}
                    children={isLoading ? t("excelExport.generating") : t("excelExport.movement")}
                  />
                </div>
              </div>
            </div>
          </ReportTop>
        </div>
      </form>
    </div>
  );
}
